import { cardNo } from '@ustra/core/src/utils/formatting-utils'

export default (value): string => {
  return cardNo(value)
}
